import PropTypes from 'prop-types';
import { parseISO, format } from 'date-fns';

const DateFormatter = ({ dateString }) => {
  const date = parseISO(dateString);
  return <time dateTime={dateString}>{format(date, 'LLL	d, yyyy')}</time>;
};

DateFormatter.propTypes = {
  dateString: PropTypes.string.isRequired,
};

export default DateFormatter;
